import React from 'react';
import { Box } from '@chakra-ui/react';
import debounce from 'debounce-promise';
import { useAuth } from '../../contexts/auth';
import BoxContent from '../../components/BoxContent';
import DataTable, { IColumns } from '../../components/DataTable';
import TituloPagina from '../../components/TituloPagina';
import api from '../../services/api';
import AsyncSelect from '../../components/form/AsyncSelect';
import FormGroup from '../../components/form/FormGroup';

type OptionType = { label: string; value: string };

const EscalasMotorista: React.FC = () => {
  const { user } = useAuth();
  const [policial, setPolicial] = React.useState<OptionType>();

  const columns: IColumns = [
    {
      field: 'sequencia',
      text: 'Id°',
      type: { name: 'text' },
      alias: 'escalas.id_escala',
      tooltip: ({ nome_escala }: any) =>
        nome_escala ? `Nome da escala: ${nome_escala}` : undefined,
    },
    {
      field: 'uni_sigla',
      text: 'Unidade',
      type: { name: 'text' },
      tooltip: ({ uni_nome }: any) => uni_nome,
    },
    {
      field: 'data_inicio',
      text: 'Início',
      type: { name: 'date', format: 'dd/MM/yyyy HH:mm:ss' },
      alias: 'escalas.data_inicio',
    },
    {
      field: 'data_fim',
      text: 'Fim',
      type: { name: 'date', format: 'dd/MM/yyyy HH:mm:ss' },
      alias: 'escalas.data_fim',
    },
    { field: 'nome_equipe', text: 'Equipe', type: { name: 'text' } },
    { field: 'nome_funcao', text: 'Função', type: { name: 'text' } },
  ];

  const options = {
    serverData: {
      url: `/escalas/irsos/relatorios/motorista`,
      headers: { Authorization: api.defaults.headers.authorization },
      serverPagination: true,
      params: `subunidades=${user.verSubunidade}&opm=${
        user.currentOpm?.uni_codigo
      }${policial ? `&mf=${policial.value}` : ''}`,
    },
    exportCsv: {
      visible: true,
      label: 'Escala',
      filename: 'escalas',
      serverPagination: false,
      columns: [
        { field: 'sequencia', title: 'Id' },
        { field: 'unidade.uni_sigla', title: 'Unidade' },
        {
          field: 'data_inicio',
          title: 'Data Início',
          date: { parseFormat: 'dd/MM/yyyy HH:mm:ss', format: 'dd/MM/yyyy' },
        },
        {
          field: 'data_inicio',
          title: 'Hora Início',
          date: { parseFormat: 'dd/MM/yyyy HH:mm:ss', format: 'HH:mm:ss' },
        },
        {
          field: 'data_fim',
          title: 'Data Fim',
          date: { parseFormat: 'dd/MM/yyyy HH:mm:ss', format: 'dd/MM/yyyy' },
        },
        {
          field: 'data_fim',
          title: 'Hora Fim',
          date: { parseFormat: 'dd/MM/yyyy HH:mm:ss', format: 'HH:mm:ss' },
        },
        { field: 'total_horas', title: 'Horas' },
        { field: 'valor_escala', title: 'Valor', number: true },
        {
          field: 'situacao_escala',
          title: 'Status',
          enum: {
            1: 'Aberta',
            2: 'Atrasada',
            3: 'Fechada',
            4: 'Confirmada',
            5: 'Homologada',
            6: 'Não Autorizada',
          },
        },

        { field: 'total_equipes', title: 'Equipes', number: true },
        { field: 'total_policial', title: 'Policiais', number: true },

        { field: 'criado_em', title: 'Data Criação', dateFormat: 'dd/MM/yyyy' },
        { field: 'criado_em', title: 'Hora Criação', dateFormat: 'HH:mm:ss' },
        { field: 'criado_por', title: 'Criado Por' },

        { field: 'pes_nome_criado_por', title: 'Atualizado Por' },
      ],
    },
  };

  const promiseItens = React.useCallback(async (inputValue: string): Promise<
    OptionType[] | undefined
  > => {
    try {
      const response = await api.get(`pessoas?query=${inputValue}`);

      const data = response.data || [];

      const responseFormated = data.map((item: any) => {
        return {
          value: item.matricula,
          label: item.dados,
          opm: item.uni_codigo,
        };
      });

      // setPessoaList(response.data);

      return responseFormated;
    } catch (error) {
      return undefined;
    }
  }, []);

  const delayedQuery = React.useCallback(
    debounce((query: string) => promiseItens(query), 500),
    [promiseItens],
  );

  return (
    <>
      <TituloPagina title="Escala de Motorista" />
      <BoxContent>
        <Box>
          <FormGroup name="Pesquisar Pm">
            <AsyncSelect
              name="pm_codigo"
              label="Pesquisar Pm"
              value={policial}
              loadOptions={(value: any) => delayedQuery(value)}
              onChange={(value: any) => setPolicial(value)}
            />
          </FormGroup>

          {policial && <DataTable columns={columns} options={options} />}
        </Box>
      </BoxContent>
    </>
  );
};

export default EscalasMotorista;
